export const tests = `
ca. 120 Abb.
ca. 240 farb. Abb. und Plänen
ca. 300 farb. Abb.
zahlreiche farb. Abb. und Pläne
mit ca. 120 farb. Abb.
ca. 400 farb. und s/w Abb.
zahlr. Abb.
approx. 143 col. and b/w and plans
mit zahlreichen farb. Abbildungen
ca. 84 farb. und  s/w Abb.
150 farb. Abb.
zahlr. farb. und s/w. Abb.
60 s/w und 61 farb. Abb. und Zeichnungen
250 farb. Abb.
205 farb. und s/w Abb.
29 s/w und 116 farb. Abb.
"ca. 50 Pläne und Zeichnungen, ca. 180 s/w und farb. Abb."
70 farb. und s/w Abb.
ca. 100 s/w Abb.
ca. 71 farb. und s/w Abb.
450 farb. und s/w Abb.
"27 Grafiken, 34 Detailpläne und 185 farb. Abb."
ca. 240 farb. und s/w Abb.
zahl. farb. und s/w Abb.
Broschüre: 64 Seiten mit zahlr. farb. Abb.\nFilm: 161 min (inkl. Trailer)
ca. 75 farb. und s/w Abb.
76 farb. und s/w Abb.
100 farb. und s/w Abb.
ca. 234 farb. und s/w Abb.
mit zahlreichen farb. und s/w Abb.
220 farb. und s/w Abb.
ca. 40 farb. und 160 s/w
280 farb. Abb. u. Pläne
mit ca. 151 farb. Abb.
ca. 400 farb. und  s/w Abb.
mit ca. 100 s/w und 20 farb. Abb.
komplette Abbildung  des 100 Meter langen Bildes mit vielen weiteren Abbildungen
mit zahlr. farb. und s/w Abb. und Plänen
ca. 150 farb. Abb. und Zeichnungen
zahlr. s/w Abb.
ca. 200 farb. und 25 s/w Abb.
Zahlr. farb. Abb.
20 farb. und 200 s/w Abb.
ca. 39 farb. Abb. und 22 s/w Abb. und Pläne
ca. 200 farb. Abb.
mit ca. 30 s/w Abb.
30 farb. Abb.
ca. 140 farb. Abb.
150 farb. und s/w Abb.
ca. 60 farb. Abb.
ca. 250 farb. und s/w Abb.
68 farb. u. 27 schw.-w. Abb.
400 farb. und s/w Abb.
250 farb. u. schw.-w. Abb. u. Pläne
"ca, 80 farb. und s/w Abb."
71 farb. und s/w Abb.
zahlr. farb. und  s/w Abb.
mit ca. 300 farb. Abb.
zahlr. farb. Abb.
285 farb. und s/w Abb.
ca. 120 farb. und s/w Abb.
100 Abb.
ca. 200 farb.und s/w
300 farb. und s/w Abb.
ca. 80 s/w und 25 farb. Abb.
130 farb. Abb.
208 farb. und s/w Abb.
mit ca. 56 farb. Abb.
108 farb. und s/w Abb.
zahlr. farb. und s/w Abb.
170 farb. und s/w Abb.
16 farb. u. 35 s/w Abb.
ca. 250 farb. und 300 s/w Abb.
309 farb. und s/w Abb.
150 col. and b/w
ca. 30 farb. und s/w Abb.
dreiseitig beschnitten, mit Leinenfälzel und Farbschnitt und mit ca. 100 farb. und s/w Abb.
ca. 185 farb. und s/w Abb.
136 farb. und s/w Abb.
mit 82 farb. Abb.
mit zahlr. farb. Abbildungen
mit ca. 92 Abb.
133 farb. und s/w Abb.
112 farb. u. 11 schw.-w. Abb.
14 farb. und 50 s/w Abb.
mit ca. 35 farb. und 20 s/w Abb.
ca. 20 s/w und 35 farb. Abb.
100 farb. Abb. und Plänen
ca. 250  farb. und  s/w Abb.
mit ca. 190 farb. und s/w Abb.
22 s/w Abb.
61 s/w Abb.
num. col.
ca. 108 s/w Abb.
1000 farb. und s/w Abb.
mit ca. 100 farb. und s/w Abb
ca. 55 schw.-w. Portraits
60 schw.-w. u. 30 farb. Abb.
ca. 150 Abb.
44 farb. und 50 s/w Abb.
mit ca. 90 farb. und 32 s/w Abb.
mit ca. 100 farb. Abb.
129 farb. Abb.
ca. 300 Abb.
ca. 100 farb. und  s/w Abb.
75 Abb.
ca. 650 farb. und s/w Abbildungen
zahl. farb. Abb.
250 farb. und s/w Abb.
mit ca. 100 Abb.
32 farb. und s/w Abb.
400
59 farb. und 19 s/w Abb.
zahlreiche Abb. und Pläne
ca. 160 farb. Abb.
300 s/w Abb. und einer CD-ROM
56 s/w und farb. Abb.
146 farb. und s/w Abb.
12 farb. u. 17 schw.-w.  Abb.
mit ca. 240 Abb.
zahlr. farb. Abb. und Pläne
54 farb. und s/w-Abb.
50 farb. und s/w Abb
linen cloth back strip and colored edge with approx. 100 col. and b/w
60
105 farb. und 48 s/w Abb. und Plänen
mit ca. 150 farb. und s/w. Abb.
130 Abb. farbig und s/w
50 farb. und s/w Abb.
40 farb. und s/w Abb.
250 col. and b/w
ca. 300 farb. Abb
mit ca. 100 farb. Fotografien
257 farb. Abb.
mit ca. 165 farb. und s/w Abb.
225 farb. und  s/w Abb.
approx. 200 col.
mit ca. 200 Abb.
mit zahlr. Abb. und Plänen
ca. 1000 farb. Abb.
90 farb. und s/w Abb.
107 farb. und s/w Abb.
ca. 100 farb.
ca. 110 schw.-w. u. farb. Abb.
137 farb und s/w Abb.
140 farb. Abb.
ca. 150 z.T. farb. Abb.
mit ca. 100 farb. und s/w Abb.
ca. 150 farb. und s/w Abb.
115 farb. Abb.
119
234 farb. und s/w Abb.
ca. 210 farb. und s/w Abb.
42 farb. und s/w Abb.
80 farb. und s/w Abb.
ca. 250 farb. Abb.
ca. 150 farb und s/w
150 farb. Abbildungen und 29 Plänen
mit zahlr. farb. und s/w Abb.
ca. 175 farb. Abb.
mit ca. 125 s/w-Abb.
138 farb. und s/w Abb.
ca. 150 farb. und  s/w Abb.
217 farb. und s/w Abb.
ca. 100 farb. Abb.
166 farb. und 12 s/ w Abb.
ca. 200 col.
ca. 35 farb. und 20 s/w Abb.
ca. 70 farb. Abb und ca. 40 Zeichnungen/Visualisierungen
200 farb. u. s/w Abb.
mit zahlr. farb. Abb.
85 s/w Abb.
100 farb. Abb.
180 farb. und s/w Abb.
102 farb. und s/w Abb.
ca. 120 farb. und s/w Abb
224 farb. und s/w Abb.
"ca. 140 schw.-w. Fotos, ca. 80 Pläne u. Zeichn."
200 farb. und s/w Abb.
ca. 65 farb. Abb.
ca. 110 s/w und farb. Abb.
ca. 100 s/w und farb. Abb.
ca. 150 farb. Abb.
mit ca 200 farb. Abb. und Plänen
ca. 180 farb. und s/w. Abb.
570 farb. und 450 s/w Abb.
mit ca. 15 farb. und s/w Abb.
ca. 155 farb. und s/w Abb.
70 farb. und 10 s/w Abb.
280 farb. und s/w Abb.
ca. 110 farb. Abb.
zahlr. Abb. u. Pläne
mit ca. 80 Abb.
ca. 70 farb. und  s/w Abb.
mit ca. 200 farb. und s/w Abb.
ca. 130 s/w Abb.
ca. 100 farb.und s/w Abb.
mit ca. 50 farb. Abb.
120 farb. Abb.
128 farb. Abb.
zahlreiche Abbildungen
ca. 120 farb. Abb.
70 farb. u. s/w Abb.
226 farb. und s/w Abb.
308 farb. und 31 s/w Abb.
ca. 90 Abb.
200 farb. und s/w Abb
with numerous col. and b/w
400 farb. Abb.
zahlreichen Abb. und Plänen
100
ca. 50 farb. Abb.
117 farb. und s/w Abb.
ca. 300 farb. Abbildungen
ca. 70 farb. und 10 s/w Abb.
`;
